<script lang="ts">
  import AuthFormHeader from "../common/AuthFormHeader.svelte";
  import Checkbox from "../../common/form/Checkbox.svelte";
  import VerificationCodeInput from "../common/VerificationCodeInput.svelte";
  import Button from "../../common/form/Button.svelte";
  import Countdown from "../common/Countdown.svelte";
  import { createForm } from "felte";
  import { validator } from "@felte/validator-yup";
  import * as yup from "yup";

  export let phoneNumber = "xxxxx-x8906";

  let codeError: boolean = false;
  const schema = yup.object({
    code: yup.string(),
    remember: yup.boolean(),
  });

  const { form, setData } = createForm({
    extend: validator({ schema }),
    onSubmit: (values) => {
      codeError = values.code.length !== 6;
    },
  });
</script>

<div class="auth-form-container">
  <div class="form-content">
    <form use:form method="POST">
      <AuthFormHeader title="Two-factor authentication" />

      <div class="mt-6 mb-6 text-dark-50">
        To continue, please enter 6-digit verification code sent to out phone
        number {phoneNumber}.
      </div>

      <div class="text-dark-200 mb-3.5">Verification Code</div>

      <VerificationCodeInput {setData} isError={codeError}/>

      <div class="mt-[70px]">
        <Checkbox name="remember" description="Remember this device" />
      </div>

      <div class="text-dark-50 font-medium mt-4">Didn’t receive a code? <Countdown /></div>

      <div class="submit-button relative mt-5">
        <Button>Continue</Button>
      </div>
    </form>
  </div>
</div>

<style lang="postcss">
  .submit-button :global(button) {
    @apply w-full text-[13px] py-3 px-0;
  }
</style>
